module.exports = __webpack_public_path__ + "img/rightprice.c3e0ce4a.svg";